var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgQrIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.6667 12.0833V11.4167H8.66667V9.41667H10.6667V10.75H12V12.0833H11.3333V13.4167H10V14.75H8.66667V12.75H10V12.0833H10.6667ZM14 14.75H11.3333V13.4167H12.6667V12.0833H14V14.75ZM2 2.75H7.33333V8.08333H2V2.75ZM3.33333 4.08333V6.75H6V4.08333H3.33333ZM8.66667 2.75H14V8.08333H8.66667V2.75ZM10 4.08333V6.75H12.6667V4.08333H10ZM2 9.41667H7.33333V14.75H2V9.41667ZM3.33333 10.75V13.4167H6V10.75H3.33333ZM12 9.41667H14V10.75H12V9.41667ZM4 4.75H5.33333V6.08333H4V4.75ZM4 11.4167H5.33333V12.75H4V11.4167ZM10.6667 4.75H12V6.08333H10.6667V4.75Z",
    fill: "#F6F8FA"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgQrIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/QRIcon.7a03a145.svg";
export { ForwardRef as ReactComponent };